import {
	GET_USER,
	GET_USER_SUCCESS,
	GET_USER_FAILURE,
	CHANGE_AVATAR,
	RESET_USER,
} from './types';

export const defaultState = {
	data: {
		approved: false,
		avatar: '',
		_id: 0,
		lastName: '',
		firstName: '',
		team: { name: '' },
	},
	isLoading: false,
	isLoaded: false,
	error: null,
};

export type IUserState = typeof defaultState;

export const user = (state = defaultState, action: any): IUserState => {
	const { payload, type } = action;
	switch (type) {
		case GET_USER:
			return {
				...state,
				isLoading: true,
				error: null,
			};
		case GET_USER_SUCCESS:
			return {
				...state,
				data: payload,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case GET_USER_FAILURE:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				error: payload,
			};
		case RESET_USER:
			return defaultState;
		case CHANGE_AVATAR:
			return {
				...state,
				data: { ...state.data, avatar: payload },
			};
		default:
			return state;
	}
};
